<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 hidden">
    <CentralHeader title="Show & Tell"></CentralHeader>
    <div class="flex flex-row items-center space-x-2">
      <input
        class="rounded p-2 bg-vectric placeholder-black w-1/5 focus:w-1/3 text-blue-900 font-semibold"
        type="search"
        v-model="search"
        placeholder="Search..."
      />
      <div v-if="true">
        <ProductFilter v-model="filteredProducts"></ProductFilter>
      </div>

      <div class="flex-1"></div>
      <router-link to="/share" v-if="loggedIn">
        <div
          class="border-darkBlue bg-vectric border-2 py-2 px-4 rounded font-semibold"
        >
          Share your project
        </div>
      </router-link>
    </div>

    <disabled-activity v-if="!allowActivity" customClass="true" />
    <div
      class="grid grid-cols-1 sm:grid-cols-2 sm:col-gap-6 lg:grid-cols-3 lg:col-gap-8 gap-6 mt-12 mb-24"
    >
      <div
        v-for="proj in filteredProjects"
        :key="proj._id"
        class="flex flex-col items-center"
      >
        <div class="">
          <router-link :to="projectUrl(proj._id)">
            <img
              class="h-80 w-80 object-cover border-4 border-vectric rounded-full mx-auto bg-white"
              :src="previewImageFor(proj)"
              alt=""
            />
          </router-link>
        </div>
        <div class="flex justify-center">
          <div class="h-6 w-1.5 bg-vectric"></div>
        </div>
        <div class=" flex justify-center">
          <router-link :to="projectUrl(proj._id)">
            <a
              class="bg-black text-white border-vectric border-4 font-semibold uppercase rounded-t-xl rounded-br-xl py-3 px-6 text-lg
          hover:bg-vectric hover:text-white"
            >
              {{ proj.projectTitle }}
            </a>
          </router-link>
        </div>

        <!--          <div class="space-y-2">-->
        <!--            <div-->
        <!--              class="p-4 font-open-sans text-lightblue tracking-wide text-xl text-center"-->
        <!--            >-->
        <!--              {{ proj.projectTitle }}-->
        <!--            </div>-->
        <!--          </div>-->
      </div>

      <!-- More people... -->
    </div>
    <if-can-take-part message="Log in to share your project"></if-can-take-part>
  </div>
</template>

<script lang="js">
window.location.href = "/";

import {sanityClient} from "../utils/sanity";
import IfCanTakePart from "../components/IfCanTakePart";
import {mapGetters} from "vuex";
import DisabledActivity from "../components/DisabledActivity";
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import CentralHeader from "../components/shared/CentralHeader";
import ProductFilter from "../components/ProductFilter";
import sanityImageBuilder from "../utils/sanityImageBuilder";
import Card from "../components/shared/Card.vue";

export default {

  name: "UserProjects",
  components: { ProductFilter, CentralHeader, DisabledActivity, IfCanTakePart},
  // props
  // data
  data() {
    return {
      multiFilter: [],
      filteredProducts: [],
      options: [
        'Aspire',
        'VCarve Pro',
        'VCarve Desktop',
        'Cut2D Pro',
        'Cut2D Desktop',
        'Cut3D',
        'PhotoVCarve'
      ],
      projects: [],
      search: '',
      subscription: null
    }
  },
  computed: {
    ...mapGetters(["loggedIn", "allowActivity"]),
    filteredProjects() {
      const searchLc = this.search.toLowerCase();
      const lowercasedMultiFilter = this.filteredProducts.map(val => val.toLowerCase());
      return this.projects.filter((proj) =>
          (!searchLc || proj.projectTitle.toLowerCase().match(searchLc)) &&
          (lowercasedMultiFilter.length === 0 || !proj.compatibility || lowercasedMultiFilter.includes(proj.compatibility.toLowerCase())))
    },
  },
  methods: {
    projectUrl(id) {
      return "/project/" + id
    },
    fetchProjects() {
      const queryString = "*[_type == 'userProject' && approved == true && !(_id in path('drafts.**'))] | order(_createdAt desc){...}";
      sanityClient
        .fetch(queryString)
        .then((res) => {
          this.projects = res;
        })
        .catch(function (err) {
          console.warn(err)
        });
    },
    previewImageFor(proj) {
      if (proj.uploadedImages && proj.uploadedImages.length > 0) {
        return sanityImageBuilder
            .image(proj.uploadedImages[0])
            .width(400)
            .height(400)
            .url();
      }
      return "";
    }
  },
  created() {
    // this.subscription = this.subscribe();
    this.fetchProjects();
  },
  beforeDestroy() {
    if (this.subscription != null) {
      this.subscription.unsubscribe()
    }
  }
}
</script>
<style scoped>
.filter-field {
  width: 20%;
  background-color: white;
}

input[type="search"] {
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}
</style>
